import { Link } from '@muse-web/router'

import { Badge, EyeClosedIcon, Tag } from '@ds/components'

import { AUDIO_CARD_LABELS } from '../../constants/audioCardStaticCopy'

import styles from './AudioCardTags.module.css'

export type TAudioCardTagLink = {
    label: string
    /** Present only when the audio cross-links the tag; a plain tag is not a link. */
    href?: string
}

export type TAudioCardTagsProps = {
    isUnlisted: boolean
    /** Empty when the id resolves to no category — nextjs then shows its error badge. */
    categoryTitle?: string
    categoryHref?: string
    links: TAudioCardTagLink[]
    extraCount: number
}

const renderTag = ({ label, href }: TAudioCardTagLink, index: number) =>
    href ? (
        <Link key={`${index}-${label}`} href={href} className={styles.link}>
            <Tag>{label}</Tag>
        </Link>
    ) : (
        <Tag key={`${index}-${label}`}>{label}</Tag>
    )

export const AudioCardTags = ({
    isUnlisted,
    categoryTitle,
    categoryHref,
    links,
    extraCount,
}: TAudioCardTagsProps) => (
    <div className={styles.tags}>
        {isUnlisted ? <Badge variant="default" Icon={EyeClosedIcon} /> : null}

        {categoryTitle && categoryHref ? (
            <Link href={categoryHref} className={styles.link}>
                <Tag>{categoryTitle}</Tag>
            </Link>
        ) : (
            <Badge variant="error">{AUDIO_CARD_LABELS.noCategory}</Badge>
        )}

        <div className={styles.visible}>{links.map(renderTag)}</div>
        {extraCount > 0 ? <Tag>{`+${extraCount}`}</Tag> : null}
    </div>
)
